module.exports = __webpack_public_path__ + "static/media/orga1.d3fdff60.svg";